/* ==========================================================================
   McDuffy Homepage V2 — Scroll reveal + counter animations
   ========================================================================== */
(function() {
  'use strict';

  /* --- Scroll Reveal --- */
  var reveals = document.querySelectorAll('[data-v2-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    reveals.forEach(function(el) { obs.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('is-visible'); });
  }

  /* --- Counter Animation --- */
  var counters = document.querySelectorAll('[data-v2-counter]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          cObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    counters.forEach(function(el) { cObs.observe(el); });
  }

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-v2-counter'));
    var suffix = el.getAttribute('data-v2-suffix') || '';
    var prefix = el.getAttribute('data-v2-prefix') || '';
    var decimals = el.hasAttribute('data-v2-decimal') ? parseInt(el.getAttribute('data-v2-decimal'), 10) : 0;
    var duration = 1200;
    var start = performance.now();
    function tick(now) {
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      var display = decimals > 0 ? val.toFixed(decimals) : Math.round(val).toLocaleString();
      el.textContent = prefix + display + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
})();
